import GameScreen from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, GameScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY
};

export const DEFAULT_BUTTON_CONFIG = { pressAnimationConfig: { scale: 0.8 }, releaseAnimationConfig: { scale: 1 } };